'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' });

var Forward = function Forward(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Forward = (0, _pure2.default)(Forward);
Forward.muiName = 'SvgIcon';

exports.default = Forward;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Forward.js
// module id = 2448
// module chunks = 0